import Vue from 'vue'
import AppointmentAvailability from 'Patterns/vue/components/AppointmentAvailability.vue'

const appointmentAvailabilitySelector = '#vue-appointment-availability'
const rootElement = document.querySelector(appointmentAvailabilitySelector)
const componentProps = rootElement.attributes['data-vue'].value

export default class AppointmentAvailabilityComponent {
  constructor () {
    this.$trigger = rootElement
    if (this.$trigger) {
      this.app = new Vue({
        el: appointmentAvailabilitySelector,
        render: createElement => createElement(AppointmentAvailability, {
          props: JSON.parse(componentProps)
        })
      })
    }
  }
}

new AppointmentAvailabilityComponent()
